import { ReactNode } from 'react';

export enum ESetLocationActionVariants {
  NAV = 'navigation',
  FILTER = 'filter',
  HERO = 'hero',
}

/**
 * Props for the `AtSetLocationAction` component.
 */
export interface IAtsetLocationActionProps {
  /**
   * Optional custom content inside the button.
   * If not provided, a default label is rendered based on the `variant`.
   */
  children?: ReactNode;
  /**
   * Function called when the button is clicked.
   */
  onClick: () => void;
  /**
   * Indicates whether the user already has a location selected.
   * If true, "[Reset]" text may appear depending on the variant and breakpoint.
   */
  hasLocation: boolean;
  /**
   * Tailwind utility classes for additional button styling.
   */
  className?: string;
  /**
   * Controls button style and logic behavior.
   * Uses the `ESetLocationActionVariants` enum.
   */
  variant: ESetLocationActionVariants;
}
